<app-popup-container-component>
  <ng-container body>
    <div>
      <div>
        <img src="./../../../../assets/images/warning-conform-icon.svg" alt="">
      </div>
      <div class="outline-border-text">
        Are you sure you want to leave ?
      </div>
      <div class="text-label-xs">
        You are trying to leave the page, all changes will be discarded.<br />
        Do you want to proceed without saving?
      </div>
      <div class="d-flex justify-content-center my-2">
        <button class="btn-white-border" mat-dialog-close type="button">Cancel</button>
        <button class="btn-success ms-2" [mat-dialog-close]="true" type="button">Proceed</button>
      </div>
    </div>

  </ng-container>
</app-popup-container-component>